import { resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-aa5a404a")

_pushScopeId("data-v-aa5a404a")
const _hoisted_1 = { class: "history-recipelist-page" }
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  const _component_CommonRecipeList = _resolveComponent("CommonRecipeList")
  const _component_CommonDialog = _resolveComponent("CommonDialog")

  return (_openBlock(), _createBlock("div", _hoisted_1, [
    _createVNode("div", {
      class: "history-recipelist-page-body",
      onScrollPassive: _cache[1] || (_cache[1] = ($event: any) => (_ctx.onScroll($event)))
    }, [
      _createVNode(_component_CommonRecipeList, {
        key: _ctx.updateDisplayKey,
        recipes: _ctx.recipeList,
        onSelectRecipe: _ctx.selectRecipe
      }, null, 8, ["recipes", "onSelectRecipe"])
    ], 32),
    _createVNode(_component_CommonDialog, {
      showDialog: _ctx.showApiErrorDialog,
      title: _ctx.getApiErrorTitle,
      message: _ctx.getApiErrorMessage,
      onNegativeClick: _ctx.cancelHandler,
      onPositiveClick: _ctx.retryHandler
    }, null, 8, ["showDialog", "title", "message", "onNegativeClick", "onPositiveClick"])
  ]))
})